// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"c1e6ea24","247":"db52debd","453":"ace6eafa","459":"5e845c27","627":"08c68075","768":"9585a1be","923":"97eb00fa","938":"13f58f22"}[chunkId] + ".chunk.js";
};